// extracted by mini-css-extract-plugin
module.exports = {"headHeight":"72px","footHeight":"260px","pageBgGray":"#f7f7f7","pageBgDark":"#313f60","scrollbarWidth":"6px","themeColor":"#019a7f"};